// uses styleguide/confirmationModal.less
import PropTypes from 'prop-types';

import React from 'react';
import CustomModal, { confirmPlacement } from './CustomModal';

function ConfirmationModal(props) {
    const confirmButton = {
        className: `sg-button-primary confirmationModal-confirm${props.isDisabled ? ' sg-disabled' : ''}`,
        label: props.confirmLabel || 'Continue',
        handler: props.confirmHandler,
        key: 'continue_button',
        isDisabled: props.isDisabled,
    };
    const cancelButton = {
        className: 'sg-button-action confirmationModal-cancel',
        label: props.cancelLabel || 'Close',
        handler: props.cancelButtonHandler ? props.cancelButtonHandler : props.closeHandler,
        key: 'cancel_button',
    };

    return (
        <CustomModal
            className={props.className}
            closeHandler={props.closeHandler}
            title={props.title}
            subTitle={props.subTitle}
            confirmPlacement={props.confirmPlacement}
            isFetching={props.isFetching}
            loadingMessage={props.loadingMessage}
            buttons={[cancelButton, confirmButton]}
            childrenWrapperClassName={props.childrenWrapperClassName}
            buttonWrapperClassName={props.buttonWrapperClassName}
            hideCloseButton={props.hideCloseButton}
            closeBtnClassName={props.closeBtnClassName}
        >
            {props.children}
        </CustomModal>
    );
}

ConfirmationModal.propTypes = {
    className: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    confirmPlacement: PropTypes.oneOf([confirmPlacement.sideNote]),
    children: PropTypes.node.isRequired,
    confirmHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    cancelLabel: PropTypes.string,
    confirmLabel: PropTypes.string,
    loadingMessage: PropTypes.string,
    isFetching: PropTypes.bool,
    isDisabled: PropTypes.bool,
    childrenWrapperClassName: PropTypes.string,
    buttonWrapperClassName: PropTypes.string,
    hideCloseButton: PropTypes.bool,
    closeBtnClassName: PropTypes.string,
    cancelButtonHandler: PropTypes.func,
};

export default ConfirmationModal;
